/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ACHTokenCreate } from '../models/ACHTokenCreate';
import type { ACHTokenDetails } from '../models/ACHTokenDetails';
import type { ACHTokenPaymentCreate } from '../models/ACHTokenPaymentCreate';
import type { ACHTokenUpdate } from '../models/ACHTokenUpdate';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import type { PaymentDetails } from '../models/PaymentDetails';
import type { RoutingResponse } from '../models/RoutingResponse';
import { request as __request } from '../core/request';

export class AchTokensVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async achTokensVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/ach/tokens/get`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns ACHTokenDetails OK
     * @throws ApiError
     */
    public static async achTokensVGetExport(
        requestBody?: PagingQuery,
    ): Promise<ACHTokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/ach/tokens/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param achTokenId
     * @param requestBody
     * @returns ACHTokenDetails OK
     * @throws ApiError
     */
    public static async achTokensVUpdateAchToken(
        achTokenId: string,
        requestBody?: ACHTokenUpdate,
    ): Promise<ACHTokenDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/ach/tokens/${achTokenId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns ACHTokenDetails Created
     * @throws ApiError
     */
    public static async achTokensVCreate(
        requestBody?: ACHTokenCreate,
    ): Promise<ACHTokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/ach/tokens`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param achTokenId
     * @param requestBody
     * @returns PaymentDetails OK
     * @throws ApiError
     */
    public static async achTokensVCharge(
        achTokenId: string,
        requestBody?: ACHTokenPaymentCreate,
    ): Promise<PaymentDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/ach/tokens/${achTokenId}/charge`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param routingNumber
     * @returns RoutingResponse OK
     * @throws ApiError
     */
    public static async achTokensVCheckRoutingNumber(
        routingNumber?: string,
    ): Promise<RoutingResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/ach/tokens/routing-check`,
            query: {
                'routingNumber': routingNumber,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns ACHTokenDetails Created
     * @throws ApiError
     */
    public static async achTokensVCreateBulk(
        requestBody?: Array<ACHTokenCreate>,
    ): Promise<Array<ACHTokenDetails>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/ach/tokens/bulk`,
            body: requestBody,
        });
        return result.body;
    }

}